import { Module } from "vuex";
import { IconesState } from "./types";

export const state: IconesState = {
  icones: [],
  selectedIcone: undefined,
};

const namespaced: boolean = true;

const getters = {
  getAll: (istate: IconesState) => istate.icones,
  getById: (istate: IconesState) => (id: number) => {
    if (id === undefined) {
      return undefined;
    } else {
      const ic = istate.icones.filter(
        (icone: any) => icone.properties.id === id
      )[0];
      return ic;
    }
  },
  getByName: (istate: IconesState) => (name: string) => {
    if (name === undefined) {
      return undefined;
    } else {
      const ic = istate.icones.filter(
        (icone: any) => icone.properties.name === name
      )[0];
      return ic;
    }
  },
};
const actions = {};
const mutations = {};

export const icones: Module<IconesState, any> = {
  namespaced,
  state,
  getters,
  actions,
  mutations,
};
